  export const BASE_URL = 'http://localhost:3002'
  //  export const BASE_URL = 'https://api.menubook.ru'; 
 
  const handleApiResponse = async (response) => {
  if (!response.ok) {
    let errorMessage = '';
    let errorData = null;
    
    try {
      errorData = await response.json();
      // Проверяем разные форматы ошибок
      errorMessage = errorData.error || errorData.message || errorData.detail || '';
    } catch (e) {
      // Если ответ не JSON
      try {
        errorMessage = await response.text();
      } catch (textError) {
        // Игнорируем
      }
    }
    
    // ✅ Если нет конкретного сообщения от сервера, генерируем понятное по статусу
    if (!errorMessage) {
      switch (response.status) {
        case 400:
          errorMessage = 'Ошибка в данных запроса. Проверьте правильность введенных данных.';
          break;
        case 401:
          errorMessage = 'Необходима авторизация. Пожалуйста, войдите в систему.';
          break;
        case 403:
          errorMessage = 'Доступ запрещен. У вас нет прав для выполнения этого действия.';
          break;
        case 404:
          errorMessage = 'Запрашиваемый ресурс не найден.';
          break;
        case 409:
          errorMessage = 'Конфликт данных. Данные были изменены другим пользователем.';
          break;
        case 429:
          errorMessage = 'Слишком много запросов. Пожалуйста, подождите и попробуйте снова.';
          break;
        case 500:
          errorMessage = 'Ошибка на сервере. Попробуйте позже или обратитесь в поддержку.';
          break;
        default:
          errorMessage = `HTTP error! status: ${response.status}`;
      }
    }
    
    const error = new Error(errorMessage);
    error.status = response.status;
    error.data = errorData;
    throw error;
  }
  
  return response.json();
  };

export const api = {
  // Поиск рецептов
  searchRecipes: async (params) => {
    console.log(params)
    const queryParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(v => queryParams.append(`${key}[]`, v));
        } else {
          queryParams.append(key, value);
        }
      }
    });
   
    const response = await fetch(`${BASE_URL}/recipe/search?${queryParams}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    const count = response.headers.get('Total-Card') 
    
    return { data, count: Number(count) };
  },
  
    // Поиск рецептов
  searchOwnerRecipes: async (params) => {
    console.log(params) 
    const response = await fetch(`${BASE_URL}/recipe/owner/${params.page}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({filter: params.key})
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    const count = response.headers.get('Total-Card') 
    
    return { data, count: Number(count) };
  },

  // Получить полный рецепт для редактирования
  getFullRecipe: async (id) => { 
    const response = await fetch(`${BASE_URL}/recipe/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return response.json();
  },
  
  addComment: async ({ recipeId, comments }) => {
  const response = await fetch(`${BASE_URL}/recipe/comments/${recipeId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ comments }),
  });
  
  if (!response.ok) {
    throw new Error('Failed to add comment');
  }
  
  const data = await response.json();
  return data;
  },

  getSort: async () => {
    const response = await fetch(`${BASE_URL}/recipe/sort`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return response.json();
  },

  // Сохранить рецепт (создать/обновить)
  saveRecipe: async (recipe) => {
    const method = recipe.id ? 'PATCH' : 'POST';
    const url = recipe.id 
      ? `${BASE_URL}/recipe/${recipe.id}`
      : `${BASE_URL}/recipe`;
    
    const response = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(recipe.data),
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return response.json();
  },
  
  // Удалить рецепт
  deleteRecipe: async (id) => {
   
    const response = await fetch(`${BASE_URL}/recipe/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json(); 
      console.log(data)
        return data;

    
   // return response.json();
  },
  
  // Поставить лайк/дизлайк
  toggleLike: async ({ recipeId, isLiked }) => {
    console.log(isLiked)
    const response = await fetch(`${BASE_URL}/recipe/${recipeId}/likes`, {
        method: isLiked ? 'PUT' : 'DELETE',
        headers: { 'Content-Type': 'application/json' }, 
        credentials: 'include',
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
        const data = await response.json();
        console.log(data)
        return data;
 
      //return response.json();
  },

  toggleDisLike: async ({ recipeId, isDisLiked }) => {
    const response = await fetch(`${BASE_URL}/recipe/${recipeId}/dislikes`, {
        method: isDisLiked ? 'PUT' : 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    
      
      const data = await response.json();
        console.log(data)
        return data;
  },

  getIngredients: async () => {
    const response = await fetch(`${BASE_URL}/ingredients`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    return handleApiResponse(response);
  },

   // 🔥 Библиотека (кэшируется надолго)
  getLibrary: async () => {
    const response = await fetch(`${BASE_URL}/lib`);
     return handleApiResponse(response);
  },
  
  // 🔥 Тарифы (кэшируются надолго)
  getRates: async () => {
    const response = await fetch(`${BASE_URL}/rate`);
     return handleApiResponse(response);
  },
  
  // 🔥 Промокоды (кэшируются надолго)
  getPromoCodes: async () => {
    const response = await fetch(`${BASE_URL}/promocode`);
     return handleApiResponse(response);
  }, 

  getImagePlan: async (params) => {
    console.log(params)
  
    const response = await fetch(`${BASE_URL}/recipe/suite`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        id: params,
      })
    });
    
    return handleApiResponse(response);
  },

  getPlan: async ({optionId, startDate, endDate}) => {
  console.log(optionId, startDate, endDate)

  const response = await fetch(`${BASE_URL}/plan/${optionId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      startDate: startDate,
      endDate: endDate,
    })
  });
   return handleApiResponse(response);
  },

  getPlanByDate: async ({optionId, date}) => { 
  
    const response = await fetch(`${BASE_URL}/plan/plane-date`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        date, 
        optionId
      })
    });
    
    return handleApiResponse(response);
  },
   
  generPlan: async ({choiceDate, title, selectedType}) => { 
    console.log(choiceDate, title, selectedType)
    const response = await fetch(`${BASE_URL}/generplan`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({  
        date: choiceDate,
        title: title, 
        type: selectedType,
      })
    }); 

     return handleApiResponse(response);
  },
 
  postPlanManual: async (plan) => { 
    console.log(plan)
    const response = await fetch(`${BASE_URL}/plan/manual`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({  
                dates: plan.date,
                mealType: plan.mealType, 
                recipeId: plan.recipeId,
                title: plan.title,
                flag: plan.flag,
      })
    }); 
    return handleApiResponse(response);
  },

  updatePlanFood: async (arr) => { 
    console.log(arr)
    const response = await fetch(`${BASE_URL}/plan/dish/${arr.planId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({  
       id: arr.id, 
       mealType: arr.mealType, 
       recipeId: arr.recipeId, 
       index: arr.index, 
       title: arr.title
      })
    }); 
    return handleApiResponse(response);
  },

  updatePlan: async (arr) => { 
    console.log(arr)
    const response = await fetch(`${BASE_URL}/plan/${arr.planId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
       body: JSON.stringify({ 
            id: arr.id, 
            cal: arr.cal, 
            category: arr.category, 
            mealType: arr.mealType, 
            index: arr.index, 
            title: arr.title,
            type: arr.selectedType,
          })
    }); 
    return handleApiResponse(response);
  },
  updatePortion: async (arr) => { 
    console.log(arr)
    const response = await fetch(`${BASE_URL}/plan/portion/${arr.planId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
       body: JSON.stringify({  
        itemId: arr.itemId,
              servings: arr.servings, 
              weight: arr.weight, 
              category: arr.category, 
              mealType: arr.mealType, 
              index: arr.index, 
              title: arr.title
            })
    }); 
     return handleApiResponse(response);
  },
  
  getFoodList: async ({ optionsId, startDate, endDate }) => {
    const response = await fetch(
      `${BASE_URL}/foodlist?optionsId=${optionsId}&startDate=${startDate}&endDate=${endDate}`,
      { credentials: 'include' }
    );
    return response.json();
  },
  
  // Сохранение списка продуктов (с отметками)
  saveFoodList: async ({ optionsId, startDate, endDate, servings, productList }) => {
    const response = await fetch(`${BASE_URL}/foodlist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ optionsId, startDate, endDate, servings, productList })
    });
    return response.json();
  },

  
  deletePlan: async ({id, date}) => {  
    const response = await fetch(`${BASE_URL}/plan/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', 
    }); 
     return handleApiResponse(response);
  },
 
   deleteDishPlan: async (arr) => {  
    const response = await fetch(`${BASE_URL}/plan/dish/${arr.planId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', 
      body: JSON.stringify({  
        recipeId: arr.id, mealType: arr.mealType, index: arr.index
      }) 
    }); 
     return handleApiResponse(response);
  }, 

  copyPlan: async (plan) => {  
    const response = await fetch(`${BASE_URL}/plan/copy`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', 
      body: JSON.stringify({  
        dates: plan.dates,
        planId: plan.planId,
        optionId: plan.title
      }) 
    }); 
     return handleApiResponse(response);
  }, 
   
  addMenuDish: async (arr) => {  
    const response = await fetch(`${BASE_URL}/plan/edit/${arr.planId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', 
      body: JSON.stringify({  
        mealType: arr.mealType,
        title: arr.title
      })
    }); 
      return handleApiResponse(response);
  }, 
 
  getRecipesBatch: async (recipeIds) => {
    if (!recipeIds || recipeIds.length === 0) return [];
    
    const response = await fetch(`${BASE_URL}/recipe/suite`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ id: recipeIds }),
    });
    
    return handleApiResponse(response);
  },

  getIngredientsBatch: async (ids) => {
    const response = await fetch(`${BASE_URL}/ingredients/suite`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ids }),
    });
    return handleApiResponse(response);
  },
};